import { RECAPTCHA_KEY } from "../creds";

export const executeRecaptcha = (action) => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      return reject("reCAPTCHA not yet loaded");
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RECAPTCHA_KEY, { action })
        .then(token => {
          resolve(token); // You can send this token to your server
        })
        .catch(err => reject(err));
    });
  });

};